import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
import WithShortCourseData from '../DataHOCs/WithShortCourseData';
import ShortCourseDetails from '../ShortCourse/ShortCourseDetails';
import ShortCourseStatsChartChannel from './ShortCourseStatsChartChannel';
import ChannelShortCourseOverviewRangeChart from './ChannelShortCourseOverviewRangeChart';
import ChannelShortCourseInstancesTable from './ChannelShortCourseInstancesTable';

const propTypes = {
    shortCourseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    channelId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    shortCourseStoreState: PropTypes.object.isRequired,
};

const defaultProps = {};

function ShortCourseAnalyticsView(props) {
    if (!props.shortCourseStoreState.initialized) {
        return null;
    }

    const shortCourse = props.shortCourseStoreState.shortCourse;
    if (!shortCourse) {
        console.warn(`Activity ${props.shortCourseId} not found in store.`);
        return null;
    }

    return (
        <div>
            <div>
                <h1 className="large-heading fl">
                    {shortCourse.title}
                </h1>
            </div>
            <div className="float-clear margin-bottom-lg" />
            <h2 className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.short_course.DETAILS_TITLE}</h2>
            <ShortCourseDetails
                {...props}
                hideLoadingIcon
                className="margin-bottom-xl"
            />
            <h2 className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.short_course.PLAYTHROUGH_TITLE}</h2>
            <ShortCourseStatsChartChannel {...props} />
            <h2 className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.short_course.INSTANCE_STATS_TITLE}</h2>
            <ChannelShortCourseOverviewRangeChart {...props} />
            <h2 className="large-heading margin-bottom-lg">{Strings['en'].analytics.overview.short_course.INSTANCE_LIST_TITLE}</h2>
            <ChannelShortCourseInstancesTable {...props} />
        </div>
    );
}

ShortCourseAnalyticsView.propTypes = propTypes;
ShortCourseAnalyticsView.defaultProps = defaultProps;

export default WithShortCourseData(ShortCourseAnalyticsView);